const toMixedUse = project => {
  return {
    ...project,
    building_type_name_en: 'Mixed-use',
    building_type_name_th: 'อาคารแบบผสม',
  };
};

const convertProject = project => {
  return project.is_mixed_use ? toMixedUse(project) : project
};

export {
  convertProject,
};



// WEBPACK FOOTER //
// ./src/utils/converter.js